import { CalendarDots } from "@phosphor-icons/react";

import type { CreatedTemplate } from "features/templates/types";

import { formatDate } from "common/helpers/utils";

import { TEMPLATE_METRICS } from "../../../../constants";
import EditableTemplateName from "./EditableTemplateName";

export default function DesktopEditTemplate({
  template,
}: {
  template: CreatedTemplate;
}) {
  const { id, name, created_at: createdAt, type } = template;

  return (
    <div className="flex justify-between items-center">
      <div className="flex flex-col">
        <EditableTemplateName templateName={name} templateId={id} />
        <div className="flex justify-between pl-2 text-black-500">
          {/* Metrics */}
          <div className="flex">
            {TEMPLATE_METRICS.map(({ icon: Icon, getLabel, getValue }) => {
              const label = getLabel(type);
              return (
                <div
                  className="flex gap-x-0.5 text-xs-medium after:block after:size-2 after:bg-text-500 after:content-['•'] after:mx-1.5 last:after:hidden"
                  key={label}
                >
                  <Icon className="size-4" />
                  {label}:<span>{getValue(template)}</span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      <div className="flex gap-x-0.5 text-xs-medium text-black-500">
        <CalendarDots className="size-4" />
        Created:<span>{formatDate(createdAt)}</span>
      </div>
    </div>
  );
}
